<script>

  import {Event} from '@/plugins/bus';

  export default {
    computed: {
      querystring() {
        if (!this.params) {
          return '';
        }
        return '?' + Object.keys(this.params).map((key) => key + '=' + this.params[key]).join('&');
      },
    },
    methods: {
      async getContainerSizes() {
        try {
          this.$wait.start('loading container sizes');
          const response = await this.$api.get(`container-sizes`);
          return response.data;
        } catch (err) {
          this.$toast.error('There was an error getting container sizes');
          return [];
        } finally {
          this.$wait.end('loading container sizes');
        }
      },
      async updateContainer(containerId, update) {
        try {
          const response = await this.$api.put(`containers/${containerId}`, update);
          this.$toast.success(`Container updated`);
          this.$bus.$emit(Event.ContainersUpdated, response);
        } catch (err) {
          this.$toast.error(`Could not update Container`);
        }
      },
      async addContainer(containerId, add) {
        try {
          const response = await this.$api.put(`containers/${containerId}`, add);
          this.$toast.success(`New Container added`);
          this.$bus.$emit(Event.ContainersUpdated, response);
        } catch (err) {
          this.$toast.error(`Could not add Container`);
        }
      },
      async deleteContainer(containerId) {
        try {
          await this.$api.delete(`containers/${containerId}`);
          this.$toast.success(`Container deleted`);
        } catch (err) {
          this.$toast.error(`Could not delete container`);
        }
      },
      async addContainerSize(sizeId, add) {
        try {
          const response = await this.$api.put(`container-sizes/${sizeId}`, add);
          this.$toast.success(`New Container Size added`);
          this.$bus.$emit(Event.ContainerSizesUpdated, response.data);
        } catch (err) {
          this.$toast.error(`Could not add Container Size`);
        }
      },
      async updateContainerSize(sizeId, update) {
        try {
          const response = await this.$api.put(`container-sizes/${sizeId}`, update);
          this.$toast.success(`Container Size updated`);
          this.$bus.$emit(Event.ContainerSizesUpdated, response.data);
        } catch (err) {
          this.$toast.error(`Could not update Container Size`);
        }
      },
      async getDepartments() {
        try {
          this.$wait.start('loading departments');
          const response = await this.$api.get(`departments`);
          return response.data;
        } catch (err) {
          this.$toast.error('There was an error getting departments');
          return [];
        } finally {
          this.$wait.end('loading departments');
        }
      },
      async checkNumberIsUnique(containerId, containerNumber) {
        try {
          const response = await this.$api.get(`containers/get-container-by-number?number=${containerNumber}`);
          const existingContainerId = response.data.id;
          return {
            valid: containerId === existingContainerId,
            data: {
              message: 'Container number must be unique'
            }
          };
        } catch (error) {
          if (error.response.status === 404) {
            return {
              valid: true
            };
          }
          this.$toast.error('There was an error checking the container number');
        }
      },
      async getContainerReportUsingQuery(query) {
        try {
          let p = {};
          for (let k in query) {
            if (query[k]) {
              p[k] = query[k];
            }
          }

          this.$wait.start('loading containers');
          const response = await this.$api.get(`containers/containers-report?${new URLSearchParams(p).toString()}`);
          return response;
        } catch (error) {
          this.$toast.error('There was an error getting containers');
          return [];
        } finally {
          this.$wait.end('loading containers');
        }
      },
    }
  };
</script>
